class point {
    name; address; type
}

class company {
    uuid;
    name = new class { full; short; }
    opf = new class { full; short; }
    id = new class { inn; kpp; ogrn; date; okved; }
    ceo = new class { name; post; }
    address = new class { value; postal; fias_id; fias_code; index }
    contacts = new class { phone; email; website; }
    edo = new class { use; name; }
    points = [ new point() ]
    $titles = {}
    $types = {}
    constructor() {
    }
}

export default company;

export function emptyPoint() { return new point() }